import { useState, useEffect } from "react";
import { useStoreDollHouseMap } from "../../store";
import {
  animationStart,
  animationEnd,
  showPopupWithContent,
  hidePopup,
} from "../../components/customEvents.js";
import { shallow } from "zustand/shallow";
import { DISTRICT_HIGHLIGHTS, TMOBILE } from "../../scripts/core/constants";

export default function DistrictHighlightHotspots({ hoverContent }) {
  const [desttmobileariaActive, setdesttmobileariaActive] = useState("");
  // const [destdolbyliveActive, setdestdolbyliveActive] = useState("");

  const [sourcetmobileariaActive, setsourcetmobileariaActive] = useState("");
  // const [sourcedolbyliveActive, setsourcedolbyliveActive] = useState("");
  const [sidrbarSelected, setSidebarSelected] = useState("");

  const [walkwayActive, setWalkwayActive] = useState("");

  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      destinationPoidSelected: state.destinationPoidSelected,
      sourcePoidSelected: state.sourcePoidSelected,
      DistrictHighlightPoiStore: state.DistrictHighlightPoiStore,
      resetDistrictHighlightPOI: state.resetDistrictHighlightPOI,
      currentSidebarMenuSelected: state.currentSidebarMenuSelected,
    }),
    shallow
  );

  const [shuttlestop, setshuttlestop] = useState(0);
  const [shuttlestopcover, setshuttlestopcover] = useState(0);

  /*
   * DISTRICT HIGHLIGHT  EXIST Route POI HIGHLIGHTING [start]
   */

  useEffect(() => {
    if (dollhouseStore.sourcePoidSelected === "") {
      setsourcetmobileariaActive("");
      // setsourcedolbyliveActive("")
    }

    if (dollhouseStore.sourcePoidSelected === "district_highlight_t_mobile") {
      setsourcetmobileariaActive("active-poi-selection");
    }
  }, [dollhouseStore.sourcePoidSelected]);

  useEffect(() => {
    if (dollhouseStore.destinationPoidSelected === "") {
      setdesttmobileariaActive("");
      // setdestdolbyliveActive("")
    }

    if (
      dollhouseStore.destinationPoidSelected === "district_highlight_t_mobile"
    ) {
      setdesttmobileariaActive("active-poi-selection");
    }
    // if(dollhouseStore.destinationPoidSelected === "park_mgm_dolby_live"){

    //   setdestdolbyliveActive("active-poi")

    // }
  }, [dollhouseStore.destinationPoidSelected]);
  /*
   * DISTRICT HIGHLIGHT  EXIST Route POI HIGHLIGHTING [ends]
   */

  /*
   * DISTRICT HIGHLIGHT  NOT EXIST Route POI HIGHLIGHTING [start]
   */
  useEffect(() => {
    document.querySelectorAll(".poi-hover").forEach((val) => {
      val.classList.remove("active-poi");
    });
    setWalkwayActive("");
    setshuttlestopcover(0);

    if (
      dollhouseStore.DistrictHighlightPoiStore ===
      "district_highlight_shuttle_stop"
    ) {
      setshuttlestop(1);
    } else if (
      dollhouseStore.DistrictHighlightPoiStore === "district_highlight_walkway"
    ) {
      setWalkwayActive("active-poi");
    } else {
      if (document.getElementById(dollhouseStore.DistrictHighlightPoiStore)) {
        document
          .getElementById(dollhouseStore.DistrictHighlightPoiStore)
          .classList.add("active-poi");
        setshuttlestop(0);
      }
    }
  }, [dollhouseStore.DistrictHighlightPoiStore]);
  /*
   * DISTRICT HIGHLIGHT  NOT EXIST Route POI HIGHLIGHTING [ends]
   */

  useEffect(() => {
    if (
      dollhouseStore.currentSidebarMenuSelected === "" ||
      dollhouseStore.currentSidebarMenuSelected !== DISTRICT_HIGHLIGHTS
    ) {
      setshuttlestopcover(0);
      setshuttlestop(0);
    }
    setSidebarSelected("");

    if (dollhouseStore.currentSidebarMenuSelected === TMOBILE) {
      setSidebarSelected("active-poi-highlight");
    } else {
      setshuttlestopcover(0);
      setshuttlestop(0);
    }
  }, [dollhouseStore.currentSidebarMenuSelected]);
  return (
    <>
      <g
        className={`poi-hover ${sidrbarSelected} ${desttmobileariaActive} ${sourcetmobileariaActive}`}
        id="district_highlight_t_mobile"
        transform="translate(3.128 937.524)"
        onTouchStart={(e) => {
          showPopupWithContent(e, "district_highlight_t_mobile");
        }}
        // onMouseOut={hidePopup}
        onMouseEnter={(e) => {
          animationStart("district_highlight_t_mobile");
          showPopupWithContent(e, "district_highlight_t_mobile");
        }}
        onMouseLeave={(e) => {
          animationEnd("district_highlight_t_mobile");
          hidePopup("district_highlight_t_mobile");
          dollhouseStore.resetDistrictHighlightPOI("");
        }}
        onTouchEnd={(e) => {
          hidePopup("district_highlight_t_mobile");
          dollhouseStore.resetDistrictHighlightPOI("");
        }}
        fill="rgba(255,255,255,0)"
      >
        <path
          id="t-mobile-arena"
          d="M-9078.758-12794.517l60.68-34.222,107.166-12.2,118.814,27.446,113.5,63.551,96.061,89.877,73.322,112.489,40.6,119.774,6.992,118.858-30.746,106.069-62.363,78.9-88.975,48.122-107.663,12.4-118.292-26.5-110.213-60.582-98.887-92.188v-551.795Z"
          transform="translate(9078.758 12840.934)"
        />
      </g>

      <g transform="translate(541.669 359.336)">
        <g
          transform="translate(1183.946 1141.714)"
          className="poi-hover"
          id="district_highlight_tram_path"
          fill="rgba(255,255,255,0)"
          onTouchStart={(e) => {
            showPopupWithContent(e, "district_highlight_tram_path");
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            animationStart("district_highlight_tram_path");
            showPopupWithContent(e, "district_highlight_tram_path");
          }}
          onMouseLeave={(e) => {
            animationEnd("district_highlight_tram_path");
            hidePopup("district_highlight_tram_path");
            dollhouseStore.resetDistrictHighlightPOI("");
          }}
          onTouchEnd={(e) => {
            hidePopup("district_highlight_tram_path");
            dollhouseStore.resetDistrictHighlightPOI("");
          }}
        >
          <path
            id="Path_2069"
            data-name="Path 2069"
            d="M-6173.083-10947.188l3.365,1.575,3.147.964,4.15.143,3.323-.626,2.843-1.123,3.2-1.971,4.465-3.151,4.618,3.837,4.127,2.408,4.07,1.351,4.265.582,5.768.233,4.162-.574,2.16,2.857,2.479,2.231,2.586,1.795,2.714,1.333,3.394,1.263,3.294.71,4.9.536h3.44l1.3,2.607,1.348,2.344,1.584,2.185,1.853,2.166,2.124,1.809,3.662,2.2,4.026,1.507,4.983,1.165.443,2.112.59,2.073.781,2.175,1.014,2.325.974,1.818,1.393,2.057,1.88,2.2,1.964,1.8,1.925,1.479,2.194,1.223,2.131.965,2.19.688v1.911l.253,3.6.5,2.662.811,2.683,1.565,3.236,1.53,2.454,2.177,2.467,2.048,1.838,1.929,1.481,1.752,1.109,1.608.879-1.065,2.232-.543,1.387-.595,1.736-.506,1.843-.345,1.646-.306,2.8-.122,2.449.122,2.245.306,1.6.852,2.127,1.138,1.7,1.318,1.51,1.27,1.028,1.115.853-17.249,22.009-3.633-2.853-2.048-.794h-3.326l-2.458.177-3.321.852-3.145,1.531-2.579,1.611-2.2,1.662-2,1.54-1.563-1.54-2.214-1.945-2.419-1.754-2.833-1.553-3.383-1.073-4.147-.688h-4.7l-3.6.688-2.173.492-1.591-2.418-1.561-1.884-1.646-1.624-2.173-1.641-1.976-1.158-2.1-.955-2.915-.884-2.764-.481-3.2-.171h-4.918l-.54-1.414-1.294-2.971-1.775-2.814-2.2-2.533-2.671-2.218-2.571-1.567-2.723-1.068-2.786-.574-3.079-.138h-1.583l-.29-3.065-.732-3.731-1.23-3.237-1.742-2.984-2.124-2.577-2.416-2.245-2.278-1.509-2.265-1.139-3.9-1.4-.128-3.265-.41-4.63-.826-3.175-1.2-2.817-1.819-2.693-2.669-2.552-2.7-2.1-2.232-1.424-2.379-1.618,1.985-4.608.984-3.107.459-3.395-.236-3.687-.813-3.385-1.242-2.831-1.88-2.64-1.7-1.5Z"
            transform="translate(6190.281 11515.431)"
          />
          <path
            id="Path_2070"
            data-name="Path 2070"
            d="M-2873.105-11874.521l5.114.32h4.1l3.494-.32,3.627-.592,4.052-1.158,3.494-1.887,3.217-2.235,2.506-2.4,2.225-2.49,2.114-2.937,2.476.979,2.148.582,2.914.4,3.655.192,3.87-.354,4.5-.821,4.69-1.547,2.933-1.631,3.21-2.655,4.1-3.522,3.687,2.069,4.422,1.832,4.909,1.233,5.611.465,4.891-.693,4.143-1.384,4.9-2.5,1.828-1.019,1.887,2.069,2.031,1.832,2.733,1.971,3.172,1.756,3.955,1.62,4.737,1.047,5.362.249,3.717-.249,4.294-1.047,2.443-.735,1.222,1.782,2.282,2.8,3.04,2.859,4.262,2.876,5.24,2.475,5.729,1.187,5.35.361,6.579-.521.65,4.293.893,3.189,1.346,3.559,1.907,3.026,2.073,2.708,3.07,2.728,2.78,2.1,2.653,1.34,6.774.541-.64,35.673-7.332,1.175-3.427,1.786-2.29,1.8-2.193,2.31-1.874,2.566-1.2,2.2-1.335,2.9-.96,3.01-.745,2.94-.438,2.292-5.518-.276h-3.273l-3.941.451-5.04,1.108-3.539,1.553-2.278,1.288-2.234,1.66-3.34,2.908-2.209,2.306-2.314,2.671-2.746-.5-3.648-.721-3.877-.365h-3.533l-3.613.488-4.887,1.618-3.975,1.875-3.529,2.337-2.8,2.371-1.824,1.673-3.635-2.05-3.992-1.753-4.585-1.3-3.013-.6h-3.841l-3.951.646-3.374,1.149-3.848,1.858-3.546,2.05-2.935-2.469-2.378-1.771-2.763-1.908-3.749-1.99-4.137-1.537-4.137-.838-3.849-.268-4.857.288-3.3.723-2.624.813-2.707-2.636-2.333-2.335-2.7-2.426-3.44-2.253-3.651-1.876-3.512-1.27-3.908-.777-5.008-.457-3.714-.086h-2.738l-1.384-4.459-1.2-4.477-2.128-4.205-2.461-3.374-3.537-3.292-4.094-2.129-7.5-.688v-36.157l7.411-.542,2.189-.749,3.227-2.5,3.173-3.512,2.7-3.86,1.617-3.274,1.33-4.036Z"
            transform="translate(4861.502 11896.596)"
          />
          <path
            id="Path_2071"
            data-name="Path 2071"
            d="M-5950.136-11182.884l29.18,20.65,39.377,26.846,38.7,25.392,62.037,39.984,57.165,35.049,36.773,22.638,35.338,20.549,41.189,23.851,58.506,29.764,54.2,23.334,47.241,16.241,36.3,10.295,41.034,8.3,39.352,4.936,36.066,1.9h37.655l46.491-1.44,51.3-3.457,85.693-6.68,108.891-11.016,144.854-17.76,36.653-5.593,30.9-5.979,33.4-7.994,25.247-9.843,14.815-9.323,13.2-10.271,12.247-12.095,14.487-16.823,15.146-21.477,12.3-20.42,12.513-24.512,10.944-23.9,10.816-27.4,11.395-31.411,21.082-74.988,19.77-81.653,13.44-58.8,9.153-35.241,6.825-24.463,14.2-41.736,10.019-23.835,11.376-23.678,17.455-30.675,18.352-28.457,20.5-28.461,30.689-36.309,18.731-20.511,28.394-27.215,39.317-32.815,25.809-17.965,22.85-13.069,30.795-17.107,31.847-15.164,21.3-9.31,23.638-9.435-.144,18.54,5.795,1.371-1.911,1.01-5,2.544-14.625,7.146-39.376,18.2-30.94,15.271-30.874,17.912-17.037,10.814-19.113,14.163-24.024,20.095-28.9,27.844-28.119,30.362-20.18,24.7-12.774,17.389-15.157,22.046-19.7,32.972-12.361,23.35-10.4,23.594-12.272,34.9-9.252,29.732-12.17,46.81-7.908,32.852-9.605,40.41-10.694,45.849-10.333,38.931-7.087,27.72-9.2,28.747-8.076,24.5-8.688,23.368-14.81,34.246-14.365,29.033-14.145,23.467-13.071,19.538-14.075,17.189-12.61,12.58-19.792,16.7-18.878,11.115-19.775,9.154-25.628,7.907-32.177,7.544-49.965,7.642-152.086,18.732-111.862,11.462-85.693,7.169-51.3,2.609-49.581,1.816h-36.039l-34.593-1.816-27.637-2.884-31.558-5.2-28.875-6.13-31.634-8.63-34.61-11.516-45.864-18.787-46.148-21.206-88.381-48.295-78.352-46.235-72.445-45.771-51.283-33.956-59-39.537-36.038-25.64,13.778-18.257Z"
            transform="translate(6099.666 11854.189)"
          />
        </g>

        <g id="dist-h-bridges" transform="translate(1103.65 1089.02)">
          <path
            className="poi-hover"
            id="district_highlight_bridge_connection_1"
            d="M-3286.872-11795.138l6.867-34.343,174.222,42.56,70.7,15.1,79.147,13.891h215.823v39.781l-237.352-.23-13.534-.563-12.966-1.472-13.6-2.523-14.979-4.289-63.326,15.193.828,93.58h-43.7v-89.725l-41.9-47.831Z"
            transform="translate(5099.758 11922.227)"
            fill="rgba(255,255,255,0.04)"
            onTouchStart={(e) => {
              showPopupWithContent(e, "district_highlight_bridge_connection_1");
            }}
            // onMouseOut={hidePopup}
            onMouseEnter={(e) => {
              animationStart("district_highlight_bridge_connection_1");
              showPopupWithContent(e, "district_highlight_bridge_connection_1");
            }}
            onMouseLeave={(e) => {
              animationEnd("district_highlight_bridge_connection_1");
              hidePopup("district_highlight_bridge_connection_1");
              dollhouseStore.resetDistrictHighlightPOI("");
            }}
            onTouchEnd={(e) => {
              hidePopup("district_highlight_bridge_connection_1");
              dollhouseStore.resetDistrictHighlightPOI("");
            }}
          />

          <g
            className={`poi-hover ${walkwayActive} `}
            id="district_highlight_bridge_connection_2"
            fill="rgba(255,255,255,0.01)"
            onTouchStart={(e) => {
              showPopupWithContent(e, "district_highlight_bridge_connection_2");
            }}
            // onMouseOut={hidePopup}
            onMouseEnter={(e) => {
              animationStart("district_highlight_bridge_connection_2");
              showPopupWithContent(e, "district_highlight_bridge_connection_2");
              setWalkwayActive("active-poi");
            }}
            onMouseLeave={(e) => {
              animationEnd("district_highlight_bridge_connection_2");
              hidePopup("district_highlight_bridge_connection_2");
              setWalkwayActive("");
              dollhouseStore.resetDistrictHighlightPOI("");
            }}
          >
            <path
              id="dist-h-bridge-1"
              d="M-6324.838-10852.764l34-55.306,58.347,34.412,149.514,53.941,121.764-.948-16.874,36.32-333.375-.052,25.8-44.9Z"
              transform="translate(6324.838 11550.662)"
            />

            <path
              id="Path_2104"
              data-name="Path 2104"
              d="M-4265.162-11644.564l18.631-18.014,28,20.988,31.7,17.354,34.967,12.111,37.009,7.1,39.881,1.846,38.209-3.65,32.191-7.436,44.794-16.484,31.461-17.488,28.672-21.131,29.193-28.344,22.061-29.84,16.819-31.756,11.218-33.77,5.063-33.85-.867-35.115-6.769-32.654-12.938-30.867-18.464-28.6,53.292-30.738,11.224,31.676,7.308,25.729,6.265,33.693,2.076,52.857,18.913,11.863-6.692,11.258-7.406,11.4-9.158,12.295-16.432,20.063,6.069,4.447-9.957,20.092-10.177,17.867-8.225,14.23-5.241,8.354-6.969,10.6-5.082,7.748-4.315,6.611-6.635,10.762h1.583l-10.235,9.262-8.038,7.039-6.375,5.232-5.916,4.043-11.322,7.668-22.031,13.488-7.4,4.283-35.329,18.434-40.634,15.715-41.969,9.777-34.647,3.127-183.194-22.07,8.594-36.592Z"
              transform="translate(5495.454 11984.9)"
            />
          </g>
        </g>

        <g
          className=" highlight_stop"
          id="district_highlight_shuttle_stop"
          opacity={shuttlestop}
          onTouchStart={(e) => {
            showPopupWithContent(e, "district_highlight_shuttle_stop");
            setshuttlestopcover(1);
          }}
          // onMouseOut={hidePopup}
          onMouseEnter={(e) => {
            if (shuttlestop === 1) {
              animationStart("district_highlight_shuttle_stop");
              showPopupWithContent(e, "district_highlight_shuttle_stop");
              setshuttlestopcover(1);
            }
          }}
          onMouseLeave={(e) => {
            if (shuttlestop === 1) {
              animationEnd("district_highlight_shuttle_stop");
              hidePopup("district_highlight_shuttle_stop");
              setshuttlestopcover(0);
              dollhouseStore.resetDistrictHighlightPOI("");
            }
          }}
          onTouchEnd={(e) => {
            hidePopup("district_highlight_shuttle_stop");
            setshuttlestopcover(0);
            dollhouseStore.resetDistrictHighlightPOI("");
          }}
        >
          <path
            id="Path_2072"
            data-name="Path 2072"
            d="M-4770.623-12820.191H-5007.34v-105.6l7.54-29.934,18.029-28.27,26.747-20.218,26.875-6.712h46.748l30.04-5.65,23.633-19.145,11.166-28.739v-570.742l-416.582-19.844-365.931-54.149-461.477-93.284h-915.126l-1084.956,23.791v262.967l48.158,1030.509,10.762,63.011,16.973,58.846,20.407,53.971,18.624,63.032,5.483,55.469-5.483,54.207-18.624,59.9-48.141,101.2-43.439,65.4-42.763,61.262-32.148,69.689-23.914,80.563-12.963,85.762v73.69l5.745,78.911,19.662,68.506,29.443,86.007,40.341,89.085,31.688,77.832,14,60.826,5.478,65.707v313.571l1258.574-.13,201.623-545.646,88.567-245.9,50.071-154.614,32.225-99.509-21.975-43.059-16.82-36.76-7.522-53.988,7.522-51.954,21.485-39.29,23.839-24.931,29-17.06,31.628-9.191,39.52-3.56,31.882,3.56,38.343,18.29,27.941,22.447,22.893,30.066,10.313,35.047,4.15,32.811-4.15,34.687-10.312,34.131-22.893,33.241-27.941,28.905-28.85,23.688-28.054,21.228-17,24.924-167.732,433.654-195.1,548.914,963.768-15.382,43.327-36.385,38.386-41.148,30.1-35.712,32.426-52.453,21.945-42.347,21.1-50.393,39.592-122.406,25.194-117.734,9.647-108.722v-526L-5431-11957.39l-6.36-57.208-9.386-58.755-9.953-39.81-13.055-46.389-15.731-42.412-21.269-42.186-58.466-98.78-50.694-52.795-59.148-55.271-40.752-37.437-25.394-26.2-9.026-13.858-6.9-14.522-5.622-15.556-4.323-14.607-4.126-17.161-2.987-16.85-2.34-16.58-.415-21.061,2.754-47.96-42.494,38.1-10.639,12.433-12.39,24.044-7.287,23.558-3.3,18.568-3.617,27.053v24.76l3.617,26.776,6.069,19.812,11.066,23.376,24.027,30.435,19.789,18.037,20.4,13.4,27.75,14.006,29.012,10.5,34.665,6.409,30.811,1.973,25.46-1.973,30.75-4.319,21.767-7.337,27.134-13.885,24.711-15.74,24.048-17.38,23.1-20.516,13.858-17.356,11.274-16.234,9.216-17.336,5.483-14.116,3.233-10.765,3.479-9.843,2.705-11,1-8.154,1.186-7.788.561-7.845.777-10.883v-21.163l-1.338-9.452-1.186-8.074-1.923-8.033-3.111-8.347-2.148-7.155-5.35-9.548-4.46-7.091-9.681-15.276-8.031-12.617-7.771-8.668-5.189-6.293-4.832-5.309-4.9-4.756-4.023-3.483-6.251-4.031-5.539-3.585-7.894-4.791-14.669-7.347-5.964-3.237-9.893-3.963-12.529-4.229-9.538-2.442-10.557-2.317-10.1-1.375-9.1-.921-8.481-.752h-27.533l-15.536,1.673-23.966,2.719-24.028,3.867-16.77,4.824,24.206,8.8,35.647,14.943,22.159,10.407,13.123,8.643,10.441,9.427,9.276,9.479,7.7,9.709,6.173,9.712,5.328,10.2,3.749,9.944,2.616,12.018,4.221,23.3,2.394,17.395,2.235,15.272,3.9,20.941,11.633,21.5,17.575,29.881,20.157,35.725,52.126,91.061,20.134,47.935,13.015,37.521,11.394,37.623,7.7,33.39,7.758,38.353,7.529,44.762,14.833,88.445,6.184,70.365,6.608,77.3,3.23,67.928v137.063l-8.526,427.831-7.848,104.083-9.625,68.072-28.6,103.757-12.443,39.85-12.636,32.976-17.765,39.27-21.31,40.931-16.943,27.417-29.137,41.73-35.579,44.1H-4375.9l-5.786-253.8v-66.4l1.216-30.329,4.145-39.271,9.484-36.35,14.871-35.795,22-37.083,17.149-20.122,33.4-30.623,39.8-30.177,52.019-39.356,53.607-40.707,48.155-28.385,46.824-25.737,58.252-30.723,57.035-32.035,24.764-20.924,17.5-22.951,10.661-19.069,6.774-20.749,1.623-20.139-1.623-22.4-1.647-16.567-7.3-18.127-11.073-17.639-12.257-9.628-13-6.595-14.428-3.455-26.086-3.335"
            transform="translate(8171.635 13806.871)"
            fill="none"
            // stroke="#12b107"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="15"
          />

          <path
            id="Path_2073"
            data-name="Path 2073"
            d="M-5835.638-8601.4h126.725"
            transform="translate(7231.215 11709.501)"
            fill="none"
            // stroke="#12b107"
            strokeWidth="15"
          />

          <path
            id="Path_2074"
            data-name="Path 2074"
            d="M-4009.743-8627.225l141.038.039"
            transform="translate(6494.91 11719.916)"
            fill="none"
            // stroke="#12b107"
            strokeWidth="15"
          />
        </g>

        {/* <g
          id="Shuttle_Stop_cover"
          transform="translate(2)"
          opacity={shuttlestopcover}
        >
          <path
            id="Path_2092"
            d="M-4773.893-12827.227l-234.218.107.187-100.9,7.243-28.773,17.53-27.506,25.467-19.506,24.872-6.141h46.694l31.316-6.18,25.084-19.666,12.627-30.463-.448-574.836-32.917-1.783-386.159-19L-5600.675-13716l-463.184-93.113-915.035-.729-1089.665,24.814v269.791l27.5,598.3,20.383,428.162,9.741,63.529,18.953,61.807,19.581,51.076,18.487,63.182,5.83,53.734-5.83,54.217-18.487,58.689-47.526,102.039-46.223,68-39.914,57.521-33.046,71.527-23.713,81.367-13.473,84.834.705,77.49,2.074,42.094,2.717,34.633,49.512,155.682,37.639,83.676,34.114,82.092,13.84,60.984,5.638,65.07,1.2,317.9h25.025l1230.466-.3h123.613l937.924-15.082h1334.017l-4-239.494-.666-75.975,1.172-39.113,3.978-38.162,9.379-35.57,15.023-35.648,21.519-36.389,16.187-19.641,34.066-30.6,144.271-109.838s28.3-17.615,80.875-46.811,129.438-69.969,129.438-69.969l25.866-21.424,17.495-23.2,11.367-19.953,7.092-21.9,1.722-20.637-3.206-40.037-7.819-19.17-11.311-18.672-13.427-10.156-13.689-7.139-15.408-3.535-26.464-3.531-2.424.463-1.217.762-.774,1.4-.222,1.4.437,1.67.559,1.088,1.386.875,1.655.588,2.1.32,2.519.391,21.079,2.662,12.986,2.877,13.1,6.3,10.524,8.287,11.507,17.561,6.691,16.258,3.179,38.3-1.333,19.717-6.6,20.252-10.268,18.463-17.34,22.486-23.6,19.709-69.121,38.721-59.623,31.574-81.369,46.432-145.5,110.33-34.157,31.443-17.539,20.414-22.13,37.83-15,35.65-10.355,37.119-3.865,39.568-1.247,59.061,1.456,116.281,2.326,106.346,1.633,66.154-1159.14.148,31.233-37.2,28.619-41.822,17.469-28.277,22.09-40.984,18.032-39.9,12.587-33.285,41.086-143.557,9.8-69.232,7.926-104.053,8.635-565.182-3.269-67.268-12.742-148.816-21.881-129.607-16.22-76.184-24.7-75.834-19.972-47.529-36.244-62.756,10.329-8.816,25.915-34.156,8.571-17.24,12.725-35.121,3.093-11.891,2.208-16.551,1.162-18.467v-21.434l-2.485-18.428-1.819-8.814-3.4-8.59-2.074-6.479-28.213-46.062-19.526-22.047-8.514-7.15-18.829-12.625-20.153-10.156-28.991-10.545-33.371-5.947h-39.635l-39.16,3.775-24.552,4.525-17.685,4.57-1.838,1.367-.545,2.65,1.021,2.371,2.063,1.436,4.5,1.521,19.913,7.207,34.023,13.879,22.833,10.834,12.6,8.078,18.98,18.277,8.052,10.627,5.708,8.385,4.913,9.666,3.383,9.516,7.262,33.57,8.317,55.1,63.4,111.551-9.622,8.541-22.374,16.223-24.295,15.373-26.993,14.244-16.832,5.76-20.494-21.529-15.75-15.73-19.8-18.254-69.821-64.951-25.238-25.373-8.886-13.66-7-14.551-8.926-27.516-4.318-18.316-5.58-32.873v-20.891l2.563-48.186-.384-2.248-2.179-1.9h-2.3l-2.621,1.131-4.783,3.945-36.9,33.637-10.453,12.719-8.932,15.242-6.951,16.793-3.117,10.842-2.715,9.363-2.574,12.928-2.764,20.248-1.63,23.146,1.63,25.621,5.338,24.666,12.783,29.482,11.1,16.76,15.146,18.428,20.277,19.324,15.742,10.234,17.352,9.414,16.612,7.939,29.814,11.113,37.427,6.828,28.677,1.58,35.64-3.727,22.253-3.42,19.917,21.342,58.262,97.99,22.641,43.539,15.13,42.836,22.143,84.688,9.189,59.311,6.522,54.924,6.114,109.984-.172,526.529-8.569,107.2-25.62,117.871-38.947,121.379-21.125,49.645-22.887,43.631-31.408,50.971-30.833,37.863-37.5,40-40.893,35-958.448,14.92,128.667-358.834,50.709-143.937,15.563-43.213,166.38-430.41,16.467-23.965,27.651-20.809,29.355-24.066,28.54-29.664,22.862-33.145,10.747-35.232,4.49-36.051-4.49-33.457-10.354-36.168-23.8-31.244-28.577-23.049-38.981-18.8-32.62-3.76-40.988,3.459-32.9,9.369-29.749,17.58-25.13,26.148-21.7,39.586-8.055,53.578,7.775,55.252,38.652,79.131-60.738,186.871-21.53,66.463-40.31,113.18-44.979,124.572-56.384,151.568-147.552,399.221-1251.306-.172-.675-309.775-5.36-66.514-13.588-59.541-34.386-85.379-37.413-83.479-29.258-85.25-19.654-68.437-5.75-77.477.185-74.234,12.764-84.836,23.833-80.215,31.684-68.816,85.929-126.111,48.627-101.887,18.93-60.8,5.559-55.025-5.471-56.182-18.85-64.26-20.227-53.639-17.141-58.42-10.483-62.738-20.282-429.768-28.576-596.693-.028-262.73,758.061-16.129,320.023-6.979,918-.844,459.355,93.441,369.6,54.863,411.436,19.48.068,565.254-9.959,27.053-22.373,18.129-28.677,5.285h-46.694l-28.465,7.238-28.094,21.291-18.553,29.119-8.077,30.627,1.1,110.672h17.729l222.634.281,1.855-.354.888-.9.9-1.607v-1.84l-1.1-2.285Z"
            transform="translate(8176.292 13809.838)"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-linejoin="round"
            strokeWidth="5"
          />
          <path
            id="Path_2093"
            data-name="Path 2093"
            d="M-3902.471-11434.317l15.374-5.169,28.836-13.734,23.186-15.357,25.209-17.855,7.709-7.694,34.461,62.447,20.07,47.685,24.282,73.508,16.164,74.751,21.587,130.729,12.411,140.533,3.726,72.914-.749,139.18-.9,65.039-6.392,364.19-8.342,99.981-10.006,70.008-40.063,142.018-14.8,36.307-16.024,35.41-22.876,43.466-15.044,25.141-28.853,41.414-35.532,42.913h-129l37.924-30.171,68.753-77.175,34.8-56.421,20.067-38.689,22.477-53.936,37.911-119.15,26.017-118.69,10.042-109.7-.557-526.471-6.61-110.816-6.672-62.441-8.882-54.795-22.844-85.357-16.335-44.22-21.287-42.031-58.582-98.64Z"
            transform="translate(6491.382 12876.013)"
            fill="none"
            stroke="#000000"
            strokeWidth="5"
          />

          <path
            id="Path_2094"
            data-name="Path 2094"
            d="M-5805.6-9498.583l11.7-31.733,16.818-46.921,29.431-79.611,35.017-93.938,35.855-95.657,70.7-191.464s2.75-7.758,15.942-44.477,36.828-102.395,36.828-102.395l49.868-143.765,17.071-54.125,51.747-157.3-22.469-45.345-16.727-36.322-7.133-52.834,7.346-50.564,21.078-37.6,22.782-24.42,28.188-16.33,31.116-8.964,38.6-3.241,30.724,3.241,37.372,17.6,27.254,22.248,21.4,28.574,10.333,34.793,4.372,31.5-4.372,33.149-10.052,34.108-21.984,32.122-26.68,27.15-32.117,26.891-26.661,19.779-17.982,26.107-90.09,233.359-66.813,173.84L-5702.17-9497.6Z"
            transform="translate(7220.295 12602.388)"
            fill="none"
            stroke="#000000"
            strokeWidth="5"
          />
        </g> */}
      </g>
    </>
  );
}
